import { Component, EventEmitter, Input, Output, OnChanges, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { InputDateComponent } from '../input-date/input-date.component';
import moment from 'moment';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { NgClass } from '@angular/common';
import { DropdownsOpenFactory } from '@shared/factories/dropdowns-open/dropdowns-open.factory';

@Component({
  selector: 'picker-data-simple',
  templateUrl: './picker-data-simple.component.html',
  standalone: true,
  imports: [
    OverlayPanelModule,
    CalendarModule,
    InputDateComponent,
    FormsModule,
    NgClass
  ]
})
export class PickerDataSimpleComponent implements OnChanges, AfterViewInit {
  tomorrow : any = moment().add(1,'days')
  pickerDataSimple: any = {
    minDate: new Date(this.tomorrow),
    inputDateField: {dateLockType: 2}
  }
  constructor(private translate: AfTranslateFactory,
    private dropdownsOpenFactory: DropdownsOpenFactory,
    private commonUtilsService: CommonUtilsService) { }
  @Input() item:any = {};
  @Input() finishIntervalDate:any = null;
  @Input() disabled: boolean = false;
  @Output() selectDate = new EventEmitter();
  @ViewChild(OverlayPanel) overlayPanelPickerDataSimple: OverlayPanel;
  @ViewChild('buttonPickerDataSimple') buttonPickerDataSimpleElement: ElementRef;

  ngAfterViewInit(): void {
    let typeOverlay: string = this.item.overlayInner?'overlayInner':'overlay';
    this.commonUtilsService.bindScrollOverlayListener(this.overlayPanelPickerDataSimple, typeOverlay);
  }

  ngOnChanges(): void {
    this.item.typeButton = this.item.type?this.item.type:'dark';
  }

  outputDate(e:any){
    let value = e.value;
    this.finishIntervalDate = value !==null? new Date(value) : value;
    if(!e.isValid){
      this.pickerDataSimple.errorText = this.translate.instant('field-type-date.invalid-date');
      this.item.error = true;
    }else{
      this.item.error = false;
      this.selectDate.emit({date: this.finishIntervalDate});
    }
  }

  changeInDate(newValue: any){
    this.finishIntervalDate = newValue;
    this.item.error = false;
    this.selectDate.emit({date: this.finishIntervalDate});
    if(this.item.overlayInner){
      // newValue.stopPropagation();
      this.dropdownsOpenFactory.closeLastDropdown();
    }else{
      this.dropdownsOpenFactory.closeDropdown();
    }
  }

  toggleFilter(e: any){
    let typeOverlay: string = this.item.overlayInner?'overlayInner':'overlay';
    this.commonUtilsService.toggleFilterOverlay(e, this.overlayPanelPickerDataSimple, typeOverlay);
  }
}
